var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1667,
    y: 5.33301,
    width: 4.66667,
    height: 9.33333,
    rx: 1,
    fill: "#808080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9167,
    y: 2.99951,
    width: 1.16667,
    height: 14,
    rx: 0.583333,
    fill: "#808080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16675,
    y: 8.49902,
    width: 4.66667,
    height: 6.17,
    rx: 1,
    fill: "#808080"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.91675,
    y: 2.99951,
    width: 1.16667,
    height: 14,
    rx: 0.583333,
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartV2);
export default __webpack_public_path__ + "static/media/chart_v2.00a4d9a656063685b07d5cef58857eee.svg";
export { ForwardRef as ReactComponent };